import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Flame, Bookmark, User, Gift } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const NavButton = ({ id, label, Icon, path }) => {
    const active = isActive(path);
    return (
      <button
        onClick={() => { if (!active) navigate(path); }}
        className="flex flex-col items-center justify-center flex-1 h-full transition-colors"
        data-testid={`nav-${id}`}
      >
        <Icon
          size={24}
          className={active ? 'text-green-600' : 'text-gray-400'}
          strokeWidth={active ? 2.5 : 2}
        />
        <span className={`text-xs mt-1 font-medium ${active ? 'text-green-600' : 'text-gray-400'}`}>
          {label}
        </span>
      </button>
    );
  };

  const rewardsActive = isActive('/rewards');

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50" data-testid="bottom-nav">
      <div className="relative flex justify-around items-center h-16 max-w-lg mx-auto">
        <NavButton id="home" label="Home" Icon={Home} path="/home" />
        <NavButton id="deals" label="Deals" Icon={Flame} path="/deals" />

        {/* Centered elevated Rewards FAB */}
        <div className="flex-1 flex items-center justify-center">
          <button
            onClick={() => { if (!rewardsActive) navigate('/rewards'); }}
            className="absolute -top-6 left-1/2 -translate-x-1/2 flex flex-col items-center"
            data-testid="nav-rewards"
          >
            <span
              className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg border-4 border-white transition-transform ${
                rewardsActive
                  ? 'bg-gradient-to-br from-amber-500 to-yellow-600 scale-105'
                  : 'bg-gradient-to-br from-amber-400 to-yellow-500 hover:scale-105'
              }`}
            >
              <Gift size={26} className="text-white" strokeWidth={2.5} />
            </span>
            <span className={`text-[11px] mt-1 font-bold ${rewardsActive ? 'text-amber-600' : 'text-amber-500'}`}>
              Rewards
            </span>
          </button>
        </div>

        <NavButton id="saved" label="Saved" Icon={Bookmark} path="/saved" />
        <NavButton id="profile" label="Profile" Icon={User} path="/profile" />
      </div>
    </div>
  );
};

export default BottomNav;
